// Bilingual translations for BICENTER AI
export const translations = {
  fr: {
    nav: {
      solutions: "Solutions BICENTER AI",
      activate: "Démarrer BICENTER AI",
      events: "AI Business & Tech",
      access: "Accès",
      roadmap: "Feuille de route",
      join: "Rejoindre",
      demo: "Demander une démo",
      contact: "Contact",
    },
    hero: {
      badge: "AI Business Operating System",
      title_1: "Building",
      title_2: "Intelligent",
      title_3: "Startups",
      subtitle: "BICENTER AI — l'écosystème intelligent d'IA pour la performance business.",
      tagline: "Structurez. Automatisez. Scalez.",
      cta_primary: "Demander une démo",
      cta_secondary: "Découvrir les solutions BICENTER AI",
      cta_tertiary: "Démarrer BICENTER AI",
      stat_1: "Décisions IA",
      stat_1_v: "< 5 min",
      stat_2: "Solutions LOB",
      stat_2_v: "4 modules",
      stat_3: "Marché IA Business",
      stat_3_v: "50 Md€",
    },
    why: {
      kicker: "Pourquoi BICENTER AI",
      title: "Un hub business IA premium, pensé pour les décideurs ambitieux.",
      subtitle: "BICENTER AI fédère startups innovantes, fondateurs, incubateurs, investisseurs et grands groupes autour d'un seul système d'exploitation intelligent.",
      items: [
        { t: "Time-to-Market accéléré", d: "Idéation, modélisation business et ajustements stratégiques en moins de 5 minutes grâce à BICENTER AI." },
        { t: "Réduction des coûts", d: "Automatisation intelligente des contrats, workflows et tâches administratives à grande échelle." },
        { t: "Décisions éclairées", d: "Pilotage stratégique temps réel et détection automatique des goulots d'étranglement." },
        { t: "Écosystème intégré", d: "4 modules LOB interconnectés couvrant modèle, automatisation, RH et performance IA." },
        { t: "Innovation continue", d: "Mises à jour permanentes, IA en évolution, roadmap publique 2026-2027." },
        { t: "Support premium", d: "Accompagnement dédié pour incubateurs, investisseurs et grands groupes." },
      ],
    },
    lob: {
      kicker: "BICENTER AI Suite",
      title: "Les 6 solutions BICENTER AI",
      subtitle: "Une suite modulaire d'IA pour structurer, automatiser et scaler chaque dimension de votre business.",
      cta: "Réserver une démo",
      day_label: "Jour de démo dédié",
      items: [
        {
          key: "lob_model",
          name: "BICENTER AI MODEL",
          day: "Mardi",
          tagline: "Idéation, business model & stratégie de croissance",
          features: ["Génération d'idées business", "Business model IA en < 5 min", "Prévisions financières & growth"],
        },
        {
          key: "lob_automation",
          name: "BICENTER AI AUTOMATION",
          day: "Jeudi",
          tagline: "Processus, contrats & workflows automatisés",
          features: ["Contrats & documents juridiques", "Emails & communication", "Workflows intelligents"],
        },
        {
          key: "lob_decision",
          name: "BICENTER AI DÉCISION",
          day: "Lundi",
          tagline: "Conseil stratégique IA & pilotage business",
          features: ["Diagnostic stratégique IA", "Recommandations personnalisées", "Ajustements business < 5 min"],
        },
        {
          key: "lob_rh",
          name: "BICENTER AI RH",
          day: "Vendredi",
          tagline: "Mise en relation IA candidats & professionnels · pilotage RH sous supervision humaine",
          features: ["Marketplace de talents Tech & IA", "Suggestions de mise en relation transparentes", "Pilotage RH temps réel sous supervision humaine"],
        },
        {
          key: "lob_leadcard",
          name: "BICENTER AI LEADCARD",
          day: "Mercredi",
          tagline: "Carte de visite électronique intelligente & capture de leads",
          features: ["eV-Card connectée premium", "Capture de leads en un scan", "Synchronisation CRM automatique"],
        },
        {
          key: "lob_speaker",
          name: "BICENTER AI SPEAKER",
          day: "Samedi",
          tagline: "Plateforme des speakers business & tech",
          features: ["Publication de disponibilités", "Gestion conférences & masterclass", "Conversion audience → business"],
        },
      ],
    },
    activate: {
      kicker: "Démarrer BICENTER AI",
      title: "Choisissez votre plateforme BICENTER AI et démarrez en quelques clics.",
      subtitle: "Chaque solution BICENTER AI dispose de sa propre plateforme dédiée avec des plans tarifaires adaptés. Sélectionnez celui qui correspond à votre étape de croissance, le paiement est sécurisé sur chaque plateforme.",
      secure_payment: "Paiements sécurisés sur les plateformes BICENTER AI officielles",
      cta_pricing: "Voir tous les tarifs",
      cta_activate: "Démarrer ce plan",
      popular: "Recommandé",
      disclaimer: "Les paiements sont traités sur les plateformes officielles BICENTER AI. Les tarifs sont susceptibles d'évoluer. Tous prix HT.",
    },
    ecosystem: {
      badge: "Écosystème BICENTER AI",
      title: "Deux plateformes complémentaires pour affirmer votre présence pro",
      subtitle: "Au-delà des 4 solutions BICENTER AI, l'écosystème vous équipe pour rayonner : votre carte de visite électronique intelligente et votre plateforme de speaker professionnel.",
      cta: "Accéder à la plateforme",
      platforms: {
        vcard: {
          name: "BICENTER AI eV-CARD",
          tagline: "Votre carte de visite électronique intelligente premium",
          description: "Une eV-Card connectée qui capture vos leads en un scan, se synchronise à votre CRM et met en avant votre profil de décideur en un clin d'œil.",
        },
        speaker: {
          name: "BICENTER AI SPEAKER",
          tagline: "La plateforme des speakers business & tech",
          description: "Faites-vous connaître comme conférencier, publiez vos disponibilités, gérez vos conférences, masterclass et podcasts, et convertissez votre audience en opportunités business.",
        },
      },
    },
    demo: {
      kicker: "Réserver une démo",
      title: "Une démo dédiée par solution BICENTER AI, chaque semaine.",
      subtitle: "Les démos BICENTER AI sont exclusivement réservées à nos solutions selon le calendrier suivant. Choisissez votre solution et nous confirmons votre créneau.",
      schedule_title: "Calendrier des démos",
      form: {
        title: "Demander ma démo · Diagnostic 15 min offert",
        sub: "Confidentiel — accès réservé aux décideurs ambitieux. Un diagnostic personnalisé de 15 minutes vous est offert à la réception de votre demande.",
        name: "Nom complet",
        email: "Email professionnel",
        company: "Entreprise / Structure",
        role: "Fonction",
        phone: "Téléphone",
        solution: "Solution BICENTER AI souhaitée",
        select_solution: "Sélectionnez une solution",
        date: "Date préférée (optionnel)",
        revenue: "Chiffre d'affaires annuel",
        revenue_select: "Sélectionnez un palier",
        revenue_ranges: {
          "0-30k": "0 à 30 K€",
          "30k-80k": "30 K€ à 80 K€",
          "80k-150k": "80 K€ à 150 K€",
          "150k+": "Plus de 150 K€",
        },
        message: "Votre objectif principal",
        submit: "Confirmer ma demande de démo",
        success: "✓ Votre demande de démo est confirmée. À réception de votre formulaire, l'équipe BICENTER AI reviendra vers vous sous 24h pour vous proposer la solution adaptée à votre situation, avec votre diagnostic personnalisé de 15 minutes offert.",
        error: "Une erreur est survenue. Merci de réessayer.",
      },
    },
    events: {
      kicker: "AI Business & Tech",
      title: "Conférences, Masterclass, Webinaires & Dîners AI Business & Tech",
      subtitle: "Rejoignez les décideurs qui construisent l'économie IA de demain. Inscriptions strictement limitées.",
      register: "S'inscrire",
      tier_label: "Niveau d'accès",
      tiers: { gratuit: "Gratuit", premium: "Premium", vip: "VIP" },
      types: {
        webinar: "Webinaire",
        masterclass: "Masterclass",
        conference: "Conférence",
        diner_business: "Dîner Business",
      },
      list: [
        {
          id: "evt-webinar-bicenter-business",
          type: "webinar",
          title: "Webinaire BICENTER AI BUSINESS",
          date: "Mardi (hebdo)",
          description: "Découverte du moteur d'idéation & business model IA. Démonstration live de BICENTER AI BUSINESS.",
          tier: "gratuit",
        },
        {
          id: "evt-webinar-bicenter-automation",
          type: "webinar",
          title: "Webinaire BICENTER AI AUTOMATION",
          date: "Jeudi (hebdo)",
          description: "Comment automatiser contrats, workflows et communication avec BICENTER AI AUTOMATION.",
          tier: "gratuit",
        },
        {
          id: "evt-masterclass-founders",
          type: "masterclass",
          title: "Masterclass Founder Stories IA",
          date: "Mensuel — 2026",
          description: "Ouverte aux founders du cercle BICENTER AI, aux fondateurs de startups & deeptech, aux investisseurs et aux conférenciers tech & IA. Retours d'expérience et stratégies.",
          tier: "premium",
        },
        {
          id: "evt-conference-lob-2026",
          type: "conference",
          title: "LAND OF BUSINESS TECH ET IA",
          date: "Novembre 2026 · Paris",
          description: "Le grand rendez-vous BICENTER AI. Décideurs, investisseurs et fondateurs réunis pour l'économie IA Europe & Afrique.",
          tier: "vip",
        },
        {
          id: "evt-diner-investisseurs",
          type: "diner_business",
          title: "DINER LAND OF BUSINESS TECH ET IA",
          date: "Sur invitation — 2026",
          description: "Networking premium entre fondateurs IA, investisseurs et conférenciers tech partenaires de BICENTER AI.",
          tier: "vip",
        },
        {
          id: "evt-podcast",
          type: "webinar",
          title: "Podcast IA Business by BICENTER AI",
          date: "Bi-mensuel",
          description: "Interviews de leaders Tech & IA, retours stratégiques, signaux faibles du marché.",
          tier: "gratuit",
        },
      ],
      form: {
        title: "Confirmer mon inscription",
        name: "Nom complet",
        email: "Email professionnel",
        company: "Entreprise / Structure",
        role: "Fonction",
        phone: "Téléphone (optionnel)",
        message: "Message (optionnel)",
        submit: "Valider mon inscription",
        success: "Inscription confirmée. Vous recevrez les détails par email.",
        error: "Une erreur est survenue. Merci de réessayer.",
      },
    },
    access: {
      kicker: "Niveaux d'accès",
      title: "Choisissez votre niveau d'engagement BICENTER AI",
      subtitle: "Trois cercles d'accès, du découvrir à l'investir. Votre startup mérite un réseau stratégique premium.",
      cta: "Rejoindre ce niveau",
      tiers: [
        {
          name: "Gratuit",
          tagline: "Découverte gratuit BICENTER AI",
          features: [
            "Accès aux webinaires hebdomadaires BICENTER AI",
            "Newsletter Founder Stories IA",
            "Démo découverte d'une solution BICENTER AI",
            "Communauté Instagram BICENTER AI",
            "Communauté Keyzanne Business",
          ],
          highlighted: false,
        },
        {
          name: "Premium",
          tagline: "Démarrer BICENTER AI",
          features: [
            "Accès aux démos BICENTER AI complètes",
            "Masterclass mensuelles Founder Stories",
            "Accès au cercle privé Premium",
            "Conférences BICENTER AI prioritaires",
            "Onboarding produit BICENTER AI",
          ],
          highlighted: true,
        },
        {
          name: "VIP",
          tagline: "Impact Premium",
          features: [
            "Mentorat IA business dédié",
            "Support prioritaire BICENTER AI",
            "Dîners Land of Business Tech & IA",
            "Cercle investisseurs BICENTER AI",
            "Place réservée au sommet Land of Business",
            "Coaching stratégique premium",
          ],
          highlighted: false,
        },
      ],
    },
    roadmap: {
      kicker: "Feuille de route 2026-2027",
      title: "La trajectoire BICENTER AI",
      subtitle: "Notre vision pour bâtir le hub IA business premium d'Europe et d'Afrique.",
      phases: [
        {
          name: "Phase 1",
          period: "Juin – Septembre 2026",
          title: "Créer l'audience qualifiée",
          items: [
            "Webinaires hebdomadaires BICENTER AI",
            "Podcast IA business & Founder Stories",
            "Funnel WhatsApp + Email + landing",
            "Objectif : 500 leads qualifiés, 100 membres Premium, 20 investisseurs partenaires",
          ],
        },
        {
          name: "Phase 2",
          period: "Novembre 2026",
          title: "LAND OF BUSINESS — Startups Tech & IA",
          items: [
            "Grand rendez-vous BICENTER AI à Paris",
            "Positionnement premium IA business Europe / Afrique",
            "Décideurs, fondateurs et investisseurs réunis",
          ],
        },
        {
          name: "Phase 3",
          period: "2027",
          title: "Communauté & Capital",
          items: [
            "Communauté privée BICENTER AI",
            "Club investisseurs",
            "Mentorat & accélérateur IA",
            "Programme sponsoring conférences",
          ],
        },
      ],
    },
    join: {
      kicker: "Rejoindre BICENTER AI",
      title: "Devenez partenaire, sponsor ou investisseur BICENTER AI",
      subtitle: "Connectez-vous aux décideurs et leaders qui construisent l'économie IA. Un cercle exclusif, orienté résultats.",
      tabs: {
        partenaire: "Partenaire",
        sponsor: "Sponsor",
        investisseur: "Investisseur",
      },
      descriptions: {
        partenaire: "Vous avez un projet IA & Tech ? BICENTER AI vous accompagne de l'idée à l'action. Co-construisez l'écosystème BICENTER AI comme intégrateur, incubateur, accélérateur ou grand groupe.",
        sponsor: "Soutenez les conférences, masterclass et dîners Land of Business Tech & IA. Visibilité premium auprès des décideurs, fondateurs et investisseurs de l'écosystème BICENTER AI.",
        investisseur: "Investisseurs, saisissez l'opportunité. Rejoignez le cercle investisseurs BICENTER AI et accédez au deal flow startups IA & deeptech pré-qualifiées.",
      },
      form: {
        name: "Nom complet",
        email: "Email professionnel",
        company: "Entreprise / Fonds / Structure",
        role: "Fonction",
        phone: "Téléphone",
        website: "Site web (optionnel)",
        budget: "Budget / Ticket d'investissement (optionnel)",
        message: "Décrivez votre projet IA & Tech ou votre opportunité",
        submit: "Faire une offre à BICENTER AI",
        success: "Votre demande a bien été reçue. L'équipe BICENTER AI vous recontacte sous 48h pour un rendez-vous.",
        error: "Une erreur est survenue. Merci de réessayer.",
      },
    },
    contact: {
      kicker: "Contact",
      title: "Parlons de votre projet IA",
      subtitle: "Un message direct à l'équipe BICENTER AI.",
      form: {
        name: "Nom complet",
        email: "Email",
        subject: "Sujet",
        message: "Votre message",
        submit: "Envoyer",
        success: "Message envoyé. Merci.",
        error: "Erreur lors de l'envoi.",
      },
    },
    footer: {
      tagline: "BICENTER AI — l'écosystème intelligent d'IA pour la performance business.",
      rights: "Tous droits réservés.",
      sections: {
        product: "Produit",
        platforms: "Plateformes",
        events: "Événements",
        company: "Entreprise",
      },
      links: {
        solutions: "Solutions BICENTER AI",
        demo: "Demander une démo",
        webinars: "Webinaires",
        masterclass: "Masterclass",
        conferences: "Conférences",
        diners: "Dîners Business",
        join: "Rejoindre",
        contact: "Contact",
        roadmap: "Feuille de route",
        legal: "Mentions légales",
        privacy: "Confidentialité (RGPD)",
        terms: "CGV",
        cookies: "Cookies",
      },
    },
    cookie: {
      title: "Cookies & confidentialité",
      body: "Nous utilisons des cookies strictement nécessaires au fonctionnement du site et, avec votre consentement, des cookies d'analyse pour améliorer votre expérience. Aucune donnée n'est partagée à des fins publicitaires sans votre accord.",
      compliance: "Conforme RGPD & lignes directrices CNIL",
      accept: "Tout accepter",
      refuse: "Essentiels uniquement",
      learn_more: "En savoir plus →",
    },
    protection: {
      blocked: "Contenu protégé BICENTER AI — copie interdite.",
    },
    common: {
      learn_more: "En savoir plus",
      submit: "Envoyer",
      loading: "Envoi…",
      required: "Champ requis",
    },
  },
  en: {
    nav: {
      solutions: "BICENTER AI Solutions",
      activate: "Start with BICENTER AI",
      events: "AI Business & Tech",
      access: "Access",
      roadmap: "Roadmap",
      join: "Join us",
      demo: "Book a demo",
      contact: "Contact",
    },
    hero: {
      badge: "AI Business Operating System",
      title_1: "Building",
      title_2: "Intelligent",
      title_3: "Startups",
      subtitle: "BICENTER AI — the intelligent AI ecosystem for business performance.",
      tagline: "Structure. Automate. Scale.",
      cta_primary: "Book a demo",
      cta_secondary: "Discover BICENTER AI solutions",
      cta_tertiary: "Start with BICENTER AI",
      stat_1: "AI Decisions",
      stat_1_v: "< 5 min",
      stat_2: "LOB Solutions",
      stat_2_v: "4 modules",
      stat_3: "AI Business Market",
      stat_3_v: "€50 Bn",
    },
    why: {
      kicker: "Why BICENTER AI",
      title: "A premium AI business hub, built for ambitious decision-makers.",
      subtitle: "BICENTER AI brings together innovative startups, founders, incubators, investors and large groups around one intelligent operating system.",
      items: [
        { t: "Accelerated Time-to-Market", d: "Ideation, business modeling and strategic adjustments in less than 5 minutes with BICENTER AI." },
        { t: "Cost reduction", d: "Intelligent automation of contracts, workflows and administrative tasks at scale." },
        { t: "Informed decisions", d: "Real-time strategic piloting and automatic bottleneck detection." },
        { t: "Integrated ecosystem", d: "4 interconnected LOB modules covering model, automation, HR and AI performance." },
        { t: "Continuous innovation", d: "Permanent updates, evolving AI, public roadmap 2026-2027." },
        { t: "Premium support", d: "Dedicated guidance for incubators, investors and large groups." },
      ],
    },
    lob: {
      kicker: "BICENTER AI Suite",
      title: "The 6 BICENTER AI solutions",
      subtitle: "A modular AI suite to structure, automate and scale every dimension of your business.",
      cta: "Book a demo",
      day_label: "Dedicated demo day",
      items: [
        {
          key: "lob_model",
          name: "BICENTER AI MODEL",
          day: "Tuesday",
          tagline: "Ideation, business model & growth strategy",
          features: ["Business idea generation", "AI business model in < 5 min", "Financial forecasts & growth"],
        },
        {
          key: "lob_automation",
          name: "BICENTER AI AUTOMATION",
          day: "Thursday",
          tagline: "Automated processes, contracts & workflows",
          features: ["Contracts & legal documents", "Emails & communication", "Smart workflows"],
        },
        {
          key: "lob_decision",
          name: "BICENTER AI DECISION",
          day: "Monday",
          tagline: "Strategic AI advisory & business piloting",
          features: ["AI strategic diagnosis", "Personalized recommendations", "Business adjustments < 5 min"],
        },
        {
          key: "lob_rh",
          name: "BICENTER AI RH",
          day: "Friday",
          tagline: "AI matching between candidates & professionals · HR piloting under human oversight",
          features: ["Tech & AI talent marketplace", "Transparent matching suggestions", "Real-time HR piloting under human oversight"],
        },
        {
          key: "lob_leadcard",
          name: "BICENTER AI LEADCARD",
          day: "Wednesday",
          tagline: "Smart electronic business card & lead capture",
          features: ["Premium connected eV-Card", "One-scan lead capture", "Automatic CRM sync"],
        },
        {
          key: "lob_speaker",
          name: "BICENTER AI SPEAKER",
          day: "Saturday",
          tagline: "The platform for business & tech speakers",
          features: ["Publish availabilities", "Manage conferences & masterclasses", "Convert audience into business"],
        },
      ],
    },
    activate: {
      kicker: "Start with BICENTER AI",
      title: "Pick your BICENTER AI platform and start in a few clicks.",
      subtitle: "Each BICENTER AI solution runs on its own dedicated platform with pricing tailored to your growth stage. Pick the plan that fits — payments are secured on every official platform.",
      secure_payment: "Secure payments on official BICENTER AI platforms",
      cta_pricing: "See all pricing",
      cta_activate: "Start this plan",
      popular: "Recommended",
      disclaimer: "Payments are processed on the official BICENTER AI platforms. Pricing may evolve. All prices VAT excluded.",
    },
    ecosystem: {
      badge: "BICENTER AI Ecosystem",
      title: "Two complementary platforms to elevate your professional presence",
      subtitle: "Beyond the 4 BICENTER AI solutions, the ecosystem equips you to stand out: your smart electronic business card and your professional speaker platform.",
      cta: "Go to platform",
      platforms: {
        vcard: {
          name: "BICENTER AI eV-CARD",
          tagline: "Your premium smart electronic business card",
          description: "A connected eV-Card that captures leads in one scan, syncs with your CRM and instantly showcases your decision-maker profile.",
        },
        speaker: {
          name: "BICENTER AI SPEAKER",
          tagline: "The platform for business & tech speakers",
          description: "Get known as a speaker, publish your availabilities, manage your conferences, masterclasses and podcasts, and convert your audience into business opportunities.",
        },
      },
    },
    demo: {
      kicker: "Book a demo",
      title: "One dedicated demo per BICENTER AI solution, every week.",
      subtitle: "BICENTER AI demos are strictly reserved for our solutions on this schedule. Pick your solution, we confirm your slot.",
      schedule_title: "Demo schedule",
      form: {
        title: "Request my demo · Free 15-min diagnosis",
        sub: "Confidential — reserved for ambitious decision-makers. A personalized 15-minute diagnosis is offered upon receipt of your request.",
        name: "Full name",
        email: "Professional email",
        company: "Company / Structure",
        role: "Role",
        phone: "Phone",
        solution: "Desired BICENTER AI solution",
        select_solution: "Select a solution",
        date: "Preferred date (optional)",
        revenue: "Annual revenue",
        revenue_select: "Select a tier",
        revenue_ranges: {
          "0-30k": "€0 to €30K",
          "30k-80k": "€30K to €80K",
          "80k-150k": "€80K to €150K",
          "150k+": "Above €150K",
        },
        message: "Your main objective",
        submit: "Confirm my demo request",
        success: "✓ Your demo request is confirmed. Upon receipt of your form, the BICENTER AI team will contact you within 24h to propose the solution tailored to your situation, together with your complimentary 15-minute personalized diagnosis.",
        error: "An error occurred. Please retry.",
      },
    },
    events: {
      kicker: "AI Business & Tech",
      title: "Conferences, Masterclasses, Webinars & AI Business & Tech Dinners",
      subtitle: "Join the decision-makers building tomorrow's AI economy. Strictly limited seats.",
      register: "Register",
      tier_label: "Access tier",
      tiers: { gratuit: "Free", premium: "Premium", vip: "VIP" },
      types: {
        webinar: "Webinar",
        masterclass: "Masterclass",
        conference: "Conference",
        diner_business: "Business Dinner",
      },
      list: [
        {
          id: "evt-webinar-bicenter-business",
          type: "webinar",
          title: "BICENTER AI BUSINESS Webinar",
          date: "Tuesday (weekly)",
          description: "Discover the ideation & AI business model engine. Live BICENTER AI BUSINESS demonstration.",
          tier: "gratuit",
        },
        {
          id: "evt-webinar-bicenter-automation",
          type: "webinar",
          title: "BICENTER AI AUTOMATION Webinar",
          date: "Thursday (weekly)",
          description: "How to automate contracts, workflows and communication with BICENTER AI AUTOMATION.",
          tier: "gratuit",
        },
        {
          id: "evt-masterclass-founders",
          type: "masterclass",
          title: "AI Founder Stories Masterclass",
          date: "Monthly — 2026",
          description: "Open to BICENTER AI circle founders, startups & deeptech founders, investors and tech & AI speakers. Field insights and strategies.",
          tier: "premium",
        },
        {
          id: "evt-conference-lob-2026",
          type: "conference",
          title: "LAND OF BUSINESS TECH & AI",
          date: "November 2026 · Paris",
          description: "The flagship BICENTER AI event. Decision-makers, investors and founders gathered for AI economy across Europe & Africa.",
          tier: "vip",
        },
        {
          id: "evt-diner-investisseurs",
          type: "diner_business",
          title: "LAND OF BUSINESS TECH & AI DINNER",
          date: "Invite-only — 2026",
          description: "Premium networking between AI founders, investors and tech speakers partnering with BICENTER AI.",
          tier: "vip",
        },
        {
          id: "evt-podcast",
          type: "webinar",
          title: "AI Business Podcast by BICENTER AI",
          date: "Bi-monthly",
          description: "Interviews with Tech & AI leaders, strategic insights and weak market signals.",
          tier: "gratuit",
        },
      ],
      form: {
        title: "Confirm my registration",
        name: "Full name",
        email: "Professional email",
        company: "Company / Structure",
        role: "Role",
        phone: "Phone (optional)",
        message: "Message (optional)",
        submit: "Validate my registration",
        success: "Registration confirmed. You will receive details by email.",
        error: "An error occurred. Please retry.",
      },
    },
    access: {
      kicker: "Access tiers",
      title: "Choose your BICENTER AI engagement",
      subtitle: "Three access circles, from discovery to investment. Your startup deserves a premium strategic network.",
      cta: "Join this tier",
      tiers: [
        {
          name: "Free",
          tagline: "Free BICENTER AI Discovery",
          features: [
            "Access to weekly BICENTER AI webinars",
            "Founder Stories AI newsletter",
            "Discovery demo of one BICENTER AI solution",
            "BICENTER AI Instagram community",
            "Keyzanne Business community",
          ],
          highlighted: false,
        },
        {
          name: "Premium",
          tagline: "Start with BICENTER AI",
          features: [
            "Access to full BICENTER AI demos",
            "Monthly Founder Stories masterclasses",
            "Access to private Premium circle",
            "Priority on BICENTER AI conferences",
            "BICENTER AI product onboarding",
          ],
          highlighted: true,
        },
        {
          name: "VIP",
          tagline: "Premium Impact",
          features: [
            "Dedicated AI business mentoring",
            "Priority BICENTER AI support",
            "Land of Business Tech & AI dinners",
            "BICENTER AI investors circle",
            "Reserved seat at Land of Business summit",
            "Premium strategic coaching",
          ],
          highlighted: false,
        },
      ],
    },
    roadmap: {
      kicker: "Roadmap 2026-2027",
      title: "The BICENTER AI trajectory",
      subtitle: "Our vision to build the premium AI business hub for Europe and Africa.",
      phases: [
        {
          name: "Phase 1",
          period: "June – September 2026",
          title: "Build the qualified audience",
          items: [
            "Weekly BICENTER AI webinars",
            "AI business podcast & Founder Stories",
            "WhatsApp + Email + landing funnel",
            "Goal: 500 qualified leads, 100 Premium members, 20 investor partners",
          ],
        },
        {
          name: "Phase 2",
          period: "November 2026",
          title: "LAND OF BUSINESS — Tech & AI Startups",
          items: [
            "Flagship BICENTER AI event in Paris",
            "Premium positioning for AI business Europe / Africa",
            "Decision-makers, founders and investors gathered",
          ],
        },
        {
          name: "Phase 3",
          period: "2027",
          title: "Community & Capital",
          items: [
            "BICENTER AI private community",
            "Investors club",
            "Mentoring & AI accelerator",
            "Conference sponsoring program",
          ],
        },
      ],
    },
    join: {
      kicker: "Join BICENTER AI",
      title: "Become a partner, sponsor or investor of BICENTER AI",
      subtitle: "Connect with decision-makers and leaders building the AI economy. An exclusive, outcome-driven circle.",
      tabs: {
        partenaire: "Partner",
        sponsor: "Sponsor",
        investisseur: "Investor",
      },
      descriptions: {
        partenaire: "Have an AI & Tech project? BICENTER AI supports you from idea to action. Co-build the BICENTER AI ecosystem as integrator, incubator, accelerator or large group.",
        sponsor: "Support Land of Business Tech & AI conferences, masterclasses and dinners. Premium visibility with decision-makers, founders and investors of the BICENTER AI ecosystem.",
        investisseur: "Investors, seize the opportunity. Join the BICENTER AI investors circle and access pre-qualified AI & deeptech startup deal flow.",
      },
      form: {
        name: "Full name",
        email: "Professional email",
        company: "Company / Fund / Structure",
        role: "Role",
        phone: "Phone",
        website: "Website (optional)",
        budget: "Budget / Investment ticket (optional)",
        message: "Describe your AI & Tech project or opportunity",
        submit: "Make an offer to BICENTER AI",
        success: "Your request has been received. The BICENTER AI team will get back to you within 48h to schedule a meeting.",
        error: "An error occurred. Please retry.",
      },
    },
    contact: {
      kicker: "Contact",
      title: "Let's talk about your AI project",
      subtitle: "A direct message to the BICENTER AI team.",
      form: {
        name: "Full name",
        email: "Email",
        subject: "Subject",
        message: "Your message",
        submit: "Send",
        success: "Message sent. Thank you.",
        error: "Sending failed.",
      },
    },
    footer: {
      tagline: "BICENTER AI — the intelligent AI ecosystem for business performance.",
      rights: "All rights reserved.",
      sections: {
        product: "Product",
        platforms: "Platforms",
        events: "Events",
        company: "Company",
      },
      links: {
        solutions: "BICENTER AI Solutions",
        demo: "Book a demo",
        webinars: "Webinars",
        masterclass: "Masterclasses",
        conferences: "Conferences",
        diners: "Business Dinners",
        join: "Join us",
        contact: "Contact",
        roadmap: "Roadmap",
        legal: "Legal notice",
        privacy: "Privacy (GDPR)",
        terms: "Terms of Sale",
        cookies: "Cookies",
      },
    },
    cookie: {
      title: "Cookies & privacy",
      body: "We use strictly necessary cookies for site operation and, with your consent, analytics cookies to improve your experience. No data is shared for advertising purposes without your agreement.",
      compliance: "GDPR compliant · CNIL guidelines",
      accept: "Accept all",
      refuse: "Essential only",
      learn_more: "Learn more →",
    },
    protection: {
      blocked: "Protected BICENTER AI content — copying not allowed.",
    },
    common: {
      learn_more: "Learn more",
      submit: "Send",
      loading: "Sending…",
      required: "Required field",
    },
  },
};

export const getT = (lang) => translations[lang] || translations.fr;
